import React, { useEffect, useState } from 'react';
import HeroSection from '../components/sections/HeroSection';
import VisionMissionSection from '../components/sections/VisionMissionSection';
import AboutPreview from '../components/sections/AboutPreview';
import ServicesSection from '../components/sections/ServicesSection';
import ServicesGridSection from '../components/sections/ServicesGridSection';
import ServicesCTASection from '../components/sections/ServicesCTASection';
import AboutHeroSection from '../components/sections/AboutHeroSection';
import AboutCompanyOverviewSection from '../components/sections/AboutCompanyOverviewSection';
import AboutQualitySafetySection from '../components/sections/AboutQualitySafetySection';
import AboutProjectManagementSection from '../components/sections/AboutProjectManagementSection';
import BusinessScopeSection from '../components/sections/BusinessScopeSection';
import AboutVisionMissionGoalsSection from '../components/sections/AboutVisionMissionGoalsSection';
import AboutCoreValuesSection from '../components/sections/AboutCoreValuesSection';
import AboutWhyUsSection from '../components/sections/AboutWhyUsSection';
import AboutTestimonialsSection from '../components/sections/AboutTestimonialsSection';
import AboutCTASection from '../components/sections/AboutCTASection';
import ProjectsHeroSection from '../components/sections/ProjectsHeroSection';
import ProjectsGridSection from '../components/sections/ProjectsGridSection';
import ContactHeroSection from '../components/sections/ContactHeroSection';
import ContactInfoSection from '../components/sections/ContactInfoSection';
import ImpactSection from '../components/sections/ImpactSection';
import ProjectsSection from '../components/sections/ProjectsSection';
import WhyChooseUs from '../components/sections/WhyChooseUs';
import NewsSection from '../components/sections/NewsSection';
import ContactCallout from '../components/sections/ContactCallout';
import MapSection from '../components/sections/MapSection';

const sectionComponents: Record<string, React.ComponentType<any>> = {
  HeroSection,
  VisionMissionSection,
  AboutPreview,
  ServicesSection,
  ServicesGridSection,
  ServicesCTASection,
  AboutHeroSection,
  AboutCompanyOverviewSection,
  AboutQualitySafetySection,
  AboutProjectManagementSection,
  BusinessScopeSection,
  AboutVisionMissionGoalsSection,
  AboutCoreValuesSection,
  AboutWhyUsSection,
  AboutTestimonialsSection,
  AboutCTASection,
  ProjectsHeroSection,
  ProjectsGridSection,
  ContactHeroSection,
  ContactInfoSection,
  ImpactSection,
  ProjectsSection,
  WhyChooseUs,
  NewsSection,
  ContactCallout,
  MapSection,
};

const Preview: React.FC = () => {
  const [sections, setSections] = useState<any[]>([]);
  const [language, setLanguage] = useState<'ar' | 'en'>('ar');

  useEffect(() => {
    const data = localStorage.getItem('page-preview-data');
    if (data) {
      try {
        const parsed = JSON.parse(data);
        setSections(parsed.sections || []);
        setLanguage(parsed.language || 'ar');
      } catch {}
    }
  }, []);

  return (
    <div className={`min-h-screen bg-gray-50 ${language === 'ar' ? 'font-cairo' : 'font-montserrat'}`} dir={language === 'ar' ? 'rtl' : 'ltr'}>
      {sections.map((section, idx) => {
        const SectionComponent = sectionComponents[section.type];
        if (!SectionComponent) return null;
        return <SectionComponent key={idx} language={language} {...section.props} />;
      })}
    </div>
  );
};

export default Preview; 